/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button, Dialog
} from '@mui/material';
import { useState } from 'react';
import {
  Body1400N,
  Body2300U,
  Body3400C,
  Body4300N,
  Body4300U,
  CLOSE_ICON,
  CONTAINED_BUTTON,
  Heading6500C,
  MONTH_SELECTOR_ICON,
} from '../../../utilities/generatedClasses';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import Icon from '../../../components/Icon';

const AddConfirmationDialog = (props) => {
  const [selectedItems, setItem] = useState(null);
  useEffect(() => {
    if (props && props.data && props.data.selectedItems) {
      setItem(props.data.selectedItems);
    }
  }, [props]);

  const handleClose = () => {
    onClose(null);
  };

  const save = () => {
    const _selectedItems = selectedItems.filter(x => x.IsSelected == true);
    for (let i = 0; i < _selectedItems.length; i++) {
      if (_selectedItems[i].Action == 'Modified' && _selectedItems[i].RcmndtnSeriesId == null) {
        _selectedItems[i].Action = 'Added';
      }
    }

    onClose(_selectedItems);
  };

  const updateSelectedRecommendations = (selectedItem) => {
    const _selectedItems = [...selectedItems];
    const _selectedItem = _selectedItems.find(x => x == selectedItem);
    _selectedItem.IsSelected = !_selectedItem.IsSelected;
    setItem(_selectedItems);
  };

  const { onClose, open, data } = props;

  return (
    <div>
      <Dialog onClose={handleClose} className="confirmation-dialog" aria-labelledby="title" open={open}>
        <div style={{ minWidth: '50vw', padding: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className={Heading6500C}>Confirm</div>

            <div
              className={CLOSE_ICON}
              onClick={handleClose}
              style={{ height: '30px', width: '30px', margin: '0px 10px' }}
             />
          </div>
          <div style={{ marginBottom: '20px' }} className={Body1400N}>
            Please confirm changes below
          </div>
          <div className="confirmed-items">
            {selectedItems && (
            <>
              <RenderItems
                items={selectedItems.filter(x => x.Action === 'Added' || x.RcmndtnSeriesId == null)}
                title="Added"
                updateSelectedRecommendations={updateSelectedRecommendations}
              />

              <RenderItems
                items={selectedItems.filter(x => x.Action === 'Modified' && x.RcmndtnSeriesId != null)}
                title="Edited"
                updateSelectedRecommendations={updateSelectedRecommendations}
              />

              <RenderItems
                items={selectedItems.filter(x => x.Action === 'Deleted' && x.RcmndtnSeriesId != null)}
                title="Deleted"
                updateSelectedRecommendations={updateSelectedRecommendations}
              />
            </>
            )}
          </div>

        </div>

        <div
          style={{
            marginTop: '30px',
            marginBottom: '30px',
            textAlign: 'center',
            minWidth: '20%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          className="btnContained"
        >
          <Button
            variant="contained"
            className={CONTAINED_BUTTON}
            onClick={save}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default AddConfirmationDialog;

const RenderItems = (props) => {
  const { title, items, updateSelectedRecommendations } = props;
  const isDeleted = title === 'Deleted';
  return (
    <div style={{ marginBottom: '16px' }}>
      <div className={Body2300U} style={{ marginBottom: '8px' }}>{title} ({items.length})</div>

      {items.map(selectedItem => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '16px',
          }}
            >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
              >
            <div style={{ width: '80%' }} className='Accordion-container'>
              <Accordion>
                <AccordionSummary
                  expandIcon={(
                    <Icon
                      classNames={`iconUpDown-rotation large_size ${MONTH_SELECTOR_ICON} ${isDeleted ? 'line-through' : ''}`}
                        />
)}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                    >
                  <div
                    className="row-flex"
                    style={{ alignItems: 'center' }}
                      >
                    <div
                      style={{ WebkitMaskImage: selectedItem.icon }}
                      className={
                            `ll_large_size icon-margin-10px MeasureIcon
                            ${classNameTriskeleParser('Measure Icon', selectedItem.Category, 'Icon')}`
                          }
                         />
                    <div className={Body3400C} style={{ textDecoration: isDeleted ? 'line-through' : 'none' }}>
                      {selectedItem.MeasureName}
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ display: 'flex', textDecoration: isDeleted ? 'line-through' : 'none' }}>
                      <div
                        className="ll_large_size"
                        style={{ margin: '0px 10px' }}
                           />
                      <div>
                        <div className="row-flex gap-10">
                          {
                         selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue && selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue.length > 0
                         && (
                         <div className="linetrought-gray">
                           {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue && selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue.length === 1 && (
                           <div className={Body4300N}>
                             {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Unit}
                           </div>
                           )}
                           {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue && selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue.length === 2 && (
                           <div className={Body4300N}>
                             {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[1].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Unit }
                           </div>
                           )}
                           {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue && selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue.length === 4 && (
                           <label className={`card_body ${Body4300N}`}>
                             sys {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[1].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[0].Unit} dia {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[2].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[3].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray_OldValue[2].Unit}
                           </label>
                           )}
                         </div>
                         )
                          }

                          { selectedItem.QtyDescrptr_Qty_UnitIdArray &&  selectedItem.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr
 === "Hours" && selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 2 && (
                          <div className={Body4300N}>
                            {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}hr{selectedItem.QtyDescrptr_Qty_UnitIdArray[1].Qty}min
                          </div>
                          )}

                          {!selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin && selectedItem.QtyDescrptr_Qty_UnitIdArray && selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 1 && (
                              <div className={Body4300N}>
                                {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Unit}
                              </div>
                          )}

                          {!selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin && selectedItem.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr
 !== "Hours" && selectedItem.QtyDescrptr_Qty_UnitIdArray && selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 2 && (
                              <div className={Body4300N}>
                                {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray[1].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Unit }
                              </div>
                          )}

                          {!selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin && selectedItem.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr
 !== "Hours" && selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 4 && (
                              <label className={`card_body ${Body4300N}`}>
                                sys {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray[1].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Unit} dia {selectedItem.QtyDescrptr_Qty_UnitIdArray[2].Qty}-{selectedItem.QtyDescrptr_Qty_UnitIdArray[3].Qty} {selectedItem.QtyDescrptr_Qty_UnitIdArray[2].Unit}
                              </label>
                          )}
                        
                        </div>


                        {selectedItem.DayOfWeekFreqcy && (
                        <label className={`card_body ${Body4300U}`}>
                          {selectedItem.DayOfWeekFreqcy.length === 7
                            ? 'DAILY'
                            : selectedItem.DayOfWeekFreqcy
                                }
                        </label>
                        )}

                        <label className={`card_footer ${Body4300N}`}>
                          {selectedItem.StartDate} - {selectedItem.EndDate}
                        </label>
                      </div>
                    </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
